<template>
  <div class="social-links">
    <div class="social-links__title">{{ specsTitle }}</div>
    <div class="social-links__wrapper">
      <a
        class="social-links__item"
        :href="links.vkHref"
      >
        <SvgIcon
          source='/images/social-v5.svg'
          icon="vk"
          size="28"
        />
      </a>
      <a
        class="social-links__item"
        :href="links.facebookHref"
      >
        <SvgIcon
          source='/images/social-v5.svg'
          icon="facebook"
          size="28"
        />
      </a>
      <a
        class="social-links__item"
        :href="links.telegramHref"
      >
        <SvgIcon
          source='/images/social-v5.svg'
          icon="telegram"
          size="28"
        />
      </a>
      <a
        class="social-links__item"
        :href="links.twitterHref"
      >
        <SvgIcon
          source='/images/social-v5.svg'
          icon="twitter"
          size="28"
        />
      </a>
    </div>
  </div>
</template>

<script>
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

  export default {
    name: 'SocialLinks',
    components: { SvgIcon },
    props: {
      title: {
        type: String,
        required: true,
      },

      links: {
        type: Object,
        required: true,
      },
    },

    computed: {
      specsTitle() {
        if (this.title === 'Разработка программного обеспечения') {
          return 'Хабр Разработка:'
        }
        return `Хабр ${this.title}:`;
      }
    }
  }
</script>